/**
 * PDS JS
 */
export const PDS = (function () {

    var pds = {

        get : function (dataset, mydexID = null) {

            /**
             * If MydexID is not null add to the POST data
             */
            var post_data = {
              dataset: dataset,
              type: 'transactional'
            };
            if(mydexID !== null){
                post_data.mydexID = mydexID;
            }
            // Get the csrf tokens from the page
            var csrf = Util.getCSRF();
            // Call the backend and return the promise
            return $.ajax({
                url: '/pds-read',
                type: 'post',
                dataType: 'json',
                data: post_data,
                headers: { 'x-csrf-token': csrf },
            });
        },

        post : function (dataset, data) {
          var csrf = Util.getCSRF();
          return $.ajax({
            url: '/pds-write',
            type: 'post',
            data: {
                dataset: dataset,
                formData: data,
                type: 'transactional',
            },
            headers: { 'x-csrf-token': csrf }
          })

        },

        update : function(dataset, data, id) {
            var csrf = Util.getCSRF();
          return $.ajax({
            url: '/pds-update',
            type: 'post',
            data: {
                dataset: dataset,
                data: data,
                datasetID: id,
                type: 'transactional',
            },
            headers: { 'x-csrf-token': csrf }
          })
        },

        delete : function (dataset, id){
            var csrf = Util.getCSRF();
            return $.ajax({
                url: '/pds-delete',
                type: 'post',
                data: {
                    dataset: dataset,
                    datasetID: id,
                    type: 'transactional'
                },
                headers: { 'x-csrf-token': csrf }
            })
        },

          /**
         * Custom serialization
         * Use to encode data as a unix timestamp
         * @param {*} node 
         */
           serialize: function (node) {

            var elements = node.elements;
            var formArray = {};

            for (var i = 0, element; element = elements[i++];) {

                var value = '';
                if (element.type === "date" && element.value != "") {

                    value = new Date(element.value).getTime() / 1000;
                    formArray[element.name] = value;
                } else {
                    if (!element.name.includes("csrf")){
                        formArray[element.name] = element.value;
                    }
                }                    
            }
            return JSON.stringify(formArray);
        }
    }

    return {
        pds: pds
    }

}());

